export default __webpack_public_path__ + "//i/components/system-notification/images//not-found-img.png";